import { apiClient } from './client';

export const eventApi = {
  getAll: (params) => apiClient.get('/events', { params }),
  getById: (id) => apiClient.get(`/events/${id}`),
  getUpcoming: () => apiClient.get('/events/upcoming'),
  getMyEvents: () => apiClient.get('/events/my-events'),
  create: (data) => apiClient.post('/events', data),
  update: (id, data) => apiClient.put(`/events/${id}`, data),
  cancel: (id) => apiClient.patch(`/events/${id}/cancel`),
  delete: (id) => apiClient.delete(`/events/${id}`),
};
